<template>
  <FoldersList :folders="folders" @route="onRoute" />
</template>

<script>
import FoldersList from '@/components/FoldersList'
import api from '@/api'
import utils from '@/utils'

export default {
  name: 'HomeView',

  components: {
    FoldersList
  },

  data () {
    return {
      folders: []
    }
  },

  created () {
    utils.tealiumTrack(this, {
      page_type: 'portal home'
    })

    api.getFolders({ categoryId: this.$categoryId, lang: this.$lang })
      .then((folders) => {
        this.folders = folders
      })
  },

  methods: {
    onRoute (route) {
      this.$emit('route', route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/HomeView.vue